import { fromUint8Array } from 'js-base64';
import { gzip } from 'pako';
import { PrintWidth } from '@/@types/print';
import {
  POS_PRINT_58MM_FONT_WEIGHT,
  POS_PRINT_FONT_FAMILY,
  POS_PRINT_80MM_FONT_WEIGHT,
  POS_PRINT_RENDERING_CSS,
} from '@/components/common/PosPrint/PosPrint.utils';

const PRINT_BOTTOM_PADDING = '25mm';

export type PrintIntentOptions = {
  copies?: number;
  printWidth: PrintWidth;
  receiptMarkup: string;
};

export function buildPrintIntentPage(
  receiptMarkup: string,
  printWidth: PrintWidth
): string {
  const width = printWidth;
  const receiptRootTypography = `font-family:${POS_PRINT_FONT_FAMILY}!important;font-weight:${
    width === '58mm' ? POS_PRINT_58MM_FONT_WEIGHT : POS_PRINT_80MM_FONT_WEIGHT
  }!important;${POS_PRINT_RENDERING_CSS}`;

  return `<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><style>@page{margin:0;size:${width} auto}*{box-sizing:border-box}html,body{margin:0;padding:0;${POS_PRINT_RENDERING_CSS}}body{width:100%;padding:0 4mm ${PRINT_BOTTOM_PADDING};color:#000;background:#fff;font-family:${POS_PRINT_FONT_FAMILY};font-size:18px}body>div{width:100%!important;font-size:18px!important;${receiptRootTypography}}body>div>div[data-print-separator]{height:0;margin:3mm 0;border-top:1px dashed #111;font-size:0!important;line-height:0}body>div>div[data-print-edge]{display:none!important}body>div>div:last-child{display:none!important}</style></head><body>${receiptMarkup}</body></html>`;
}

export function buildPrintIntentUrl({
  copies = 1,
  printWidth,
  receiptMarkup,
}: PrintIntentOptions): string {
  const normalizedCopies = Number.isFinite(copies)
    ? Math.max(1, Math.floor(copies))
    : 1;
  const page = buildPrintIntentPage(receiptMarkup, printWidth);
  const encodedPages = fromUint8Array(
    gzip(JSON.stringify(Array.from({ length: normalizedCopies }, () => page)))
  );

  return `intent://#Intent;scheme=print-intent;S.content=${encodeURIComponent(
    encodedPages
  )};end`;
}

export function isAndroidDevice(
  userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent
): boolean {
  return /Android/i.test(userAgent);
}

export function dispatchPrintIntent(
  element: HTMLElement | null,
  options: Omit<PrintIntentOptions, 'receiptMarkup'>,
  onStillVisible: () => void
): boolean {
  if (!element || typeof window === 'undefined') return false;

  window.location.assign(
    buildPrintIntentUrl({
      ...options,
      receiptMarkup: element.outerHTML,
    })
  );
  window.setTimeout(() => {
    if (document.visibilityState === 'visible') onStillVisible();
  }, 1500);
  return true;
}
